import React, { useState } from 'react';
import Navbar from '../Navbar';
import { Container, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { hideLoader, showLoader } from '../../util/loader/CustomLoader';
import DevAuthAPI from '../../api/DevAuth';
import { CustomToast } from '../../util/custom-toast/CustomToast';
import { useHistory, useLocation } from 'react-router-dom';

import checkEmail from '../../Assets/checkEmail.png';
const ResetLink = () => {
    const [attempt, setAttempt] = useState(1);
    let location = useLocation();
    const query = new URLSearchParams(location.search);
    const email = query.get('email');

    const sendResetLink = () => {
        showLoader();
        var api = new DevAuthAPI();
        api.forgotPassword({ email: email })
            .then((response) => {
                hideLoader();
                setAttempt(attempt + 1);
                CustomToast(
                    `Please check your email to change password : Attempt ${
                        attempt + 1
                    }`
                );
            })
            .catch((error) => {
                hideLoader();
                CustomToast(error.response.data.message);
            });
    };

    return (
        <React.Fragment>
            <Navbar showSignup={true} />
            <Container fluid className="main-container">
                <Modal show={true} centered contentClassName="mail-modal p-2">
                    <Modal.Body>
                        <Container className="text-center col-xs-1">
                            <img alt="" src={checkEmail} height="25" />
                            <h4 className="mt-2">Check your mail</h4>
                            <p className="mt-4">
                                A password reset link has been sent to your
                                registered email.
                            </p>

                            {attempt < 3 ? (
                                <>
                                    <p>
                                        Use the link in the mail to reset your
                                        password.
                                    </p>

                                    <p
                                        className="link"
                                        onClick={() => sendResetLink()}
                                    >
                                        Didn't receive mail? Resend
                                    </p>
                                </>
                            ) : (
                                <>
                                    <p>
                                        Password Reset maximum attempts reached,
                                        please try after 5 mins.
                                    </p>
                                    <Link to="/login">
                                        <p className="link">Signin</p>
                                    </Link>
                                </>
                            )}
                        </Container>
                    </Modal.Body>
                </Modal>
            </Container>
        </React.Fragment>
    );
};

export default ResetLink;
